import { notify } from "@helpers"

export default function useActions(
    salon: Model.Response<Jury.Resources.Salon>, 
    api: Jury.Models.Salon.Api, 
    methods: Jury.Models.Salon.Methods
): Jury.Models.Salon.Actions {
    return {
        
    }
}